import { Card, CardContent, CircularProgress } from "@mui/material";
import { Box } from "@mui/system";

function GraphLoadingScreen() {
  return (
    <Card sx={{ my: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <Box sx={{ height: 300 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "text.secondary",
            }}
          >
            <CircularProgress />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export { GraphLoadingScreen };
